
import { v4 as uuidv4 } from "uuid";

import CommonUtilities from "@utilities/common_utilities";

const common_util = CommonUtilities.getInstance();

export class DiceRoll {
  true_id = "";
  size = 4;
  count = 0;
  flat = 0;

  constructor(obj?: any) {
    this.true_id = obj && obj.true_id ? obj.true_id : uuidv4().toString();
    if (obj) {
      this.size = obj.size !== undefined ? +obj.size : 4;
      this.count = obj.count ? +obj.count : 0;
      this.flat = obj.flat ? +obj.flat : 0;
      if (obj && obj.log) {
        console.log(obj);
        console.log(this);
      }
    }
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      size: this.size,
      count: this.count,
      flat: this.flat
    };
  }

  get_roll(): number[] {
    const results: number[] = [];
    if (this.size === 1) {
      results.push(this.count);
    } else {
      let count = this.count;
      let reverse = false;
      if (count < 0) {
        count *= -1;
        reverse = true;
      }
      for (let i = 0; i < count; ++i) {
        const roll = common_util.get_random(this.size);
        if (reverse) {
          results.push(-1 * roll);
        } else {
          results.push(roll);
        }
      }
    }
    return results;
  }

  copy(copyMe: DiceRoll, drop_ids: boolean): void {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
    }
    this.size = copyMe.size;
    this.count = copyMe.count;
    this.flat = copyMe.flat;
  }

  clone(drop_ids: boolean): DiceRoll {
    const new_obj = new DiceRoll();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  clean() {
    if (this.count === 0 && this.size !== 0) {
      this.size = 0;
    }
    if (this.size === 0 && this.count !== 0) {
      this.count = 0;
    }
  }
}